import type React from 'react'
import { CartProjectionProvider } from './contexts/CartProjectionProvider'
import { useRef } from 'react'

import { PlaceSearchFailureProvider } from 'tripPlanner/assistant/contexts/PlaceSearchFailureContext'
import { PromptManagementProvider, type PromptManagementContextValue } from './contexts/PromptManagementContext'
import { TripPlannerChatProvider, type TripPlannerChatProviderProps } from './contexts/TripPlannerChatProvider'
import { TripPlannerEventBusProvider } from 'tripPlanner/assistant/contexts/TripPlannerEventBus'
import { DEFAULT_TURN_AUTHORITY_SNAPSHOT, TurnAuthoritySnapshotContext } from './contexts/TurnAuthoritySnapshotContext'

export interface TripChatRuntimeProps extends Omit<TripPlannerChatProviderProps, 'children'> {
  promptContextValue: PromptManagementContextValue
  children: React.ReactNode
}

function TripChatRuntime({ promptContextValue, children, ...chatProviderProps }: TripChatRuntimeProps) {
  const turnAuthoritySnapshotRef = useRef({ ...DEFAULT_TURN_AUTHORITY_SNAPSHOT })

  return (
    <PromptManagementProvider value={promptContextValue}>
      <TripPlannerEventBusProvider>
        <PlaceSearchFailureProvider>
          <TurnAuthoritySnapshotContext.Provider value={turnAuthoritySnapshotRef}>
            <TripPlannerChatProvider {...chatProviderProps}>
              <CartProjectionProvider isLoggedIn={chatProviderProps.isLoggedIn}>
                {children}
              </CartProjectionProvider>
            </TripPlannerChatProvider>
          </TurnAuthoritySnapshotContext.Provider>
        </PlaceSearchFailureProvider>
      </TripPlannerEventBusProvider>
    </PromptManagementProvider>
  )
}

export default TripChatRuntime
